<template>
  <div
    class="selectItem_cba"
    :class="themeClass"
    :style="{ width: options.widthVw ? `${options.widthVw}vw` : 'auto' }"
  >
    <el-select
      v-model="value"
      :placeholder="options.placeholder"
      :popper-append-to-body="false"
      popper-class="selectItem_popper"
      :filterable="options.isFilterable"
      @change="changeVal"
    >
      <el-option
        v-for="item in options.list"
        :key="item[options.keyValArr[0]]"
        :label="item[options.keyValArr[1]]"
        :value="item[options.keyValArr[0]]"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'selectItem_cba',
  props: {
    options: {
      type: Object,
      default: () => ({
        list: [
          {
            id: '选项1',
            name: '黄金糕',
          },
          {
            id: '选项2',
            name: '双皮奶',
          },
        ],
        keyValArr: ['id', 'name'],
        placeholder: '请选择',
        isFilterable: false, // 是否可以搜索查询
        widthVw: 9.74, // 选择框的宽度
        curVal: '', // 初始化组件的时候需要，之后逻辑中不需要
        state: '', //类型：通过它，在组件的父级中可以给不同的属性赋值
      }),
    },
    curVal: {
      type: String,
      default: '',
    },
    themeClass: {
      type: String,
      default: '',
    },
  },
  watch: {
    curVal(newVal, oldVal) {
      console.debug('selectItem_cba:', newVal, this.options.state, oldVal)
      if (newVal !== oldVal) {
        this.value = newVal
      }
    },
  },
  data() {
    return {
      value: '',
    }
  },
  created() {
    this.value = this.curVal
  },
  methods: {
    changeVal(val) {
      this.$emit('changeValEvent', {
        state: this.options.state,
        val,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.selectItem_cba {
  position: relative;
}
</style>
<style lang="scss">
.selectItem_cba {
  .el-select {
    .el-input {
      font-size: 0.972vw;
      .el-input__inner {
        height: 2.083vw;
        padding: 0 2.083vw 0 0.694vw;
        line-height: calc(2.083vw - 0.138vw - 0.138vw);
        border-radius: 0.278vw;
        border-width: 0.138vw;
        background-color: var(--mixtmt_greyColor8);
        border-color: var(--mixtmt_greyColor8);
        &:focus,
        &:active {
          /* border-color: var(--mixtmt_mainColor8); */
          background-color: var(--mixtmt_greyColor8);
        }
      }
      .el-select__caret {
        font-size: 0.927vw;
      }
      .el-input__icon {
        width: 0.694vw;
        line-height: 2.083vw;
      }
    }
    .el-icon-arrow-up::before {
      /* content: '\e79a'; */
      border-color: var(--mixtmt_greyColor8);
      color: var(--mixtmt_greyColor6);
    }
  }
  &.whiteBg {
    .el-select {
      .el-input {
        .el-input__inner {
          line-height: calc(2.083vw - 2px);
          border-width: 1px;
          background-color: transparent;
          border-color: var(--mixtmt_greyColor7);
          &:focus,
          &:active {
            /* border-color: var(--mixtmt_mainColor8); */
            background-color: transparent;
          }
        }
      }
      .el-icon-arrow-up::before {
        /* content: '\e79a'; */
        border-color: var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor6);
      }
    }
  }
  &.height40 {
    .el-select {
      .el-input {
        .el-input__inner {
          height: 2.778vw;
          line-height: calc(2.778vw - 2px);
        }
        .el-input__icon {
          width: 0.694vw;
          line-height: 2.778vw;
        }
      }
    }
  }
  &.transparentBg {
    .el-select {
      .el-input {
        .el-input__inner {
          line-height: calc(2.083vw - 2px);
          border-width: 1px;
          background-color: transparent;
          border-color: transparent;
          color: var(--mixtmt_whiteColor);
          &:focus,
          &:active {
            /* border-color: var(--mixtmt_mainColor8); */
            background-color: transparent;
          }
        }
      }
      .el-icon-arrow-up::before {
        /* content: '\e79a'; */
        border-color: transparent;
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  &.playerDetail_select {
    .el-select {
      .el-input {
        .el-input__inner {
          height: 2.778vw;
          line-height: calc(2.778vw - 2px);
          font-size: 1.388vw;
          font-weight: bold;
        }
        .el-input__icon {
          width: 0.694vw;
          line-height: 2.778vw;
          font-weight: bold;
        }
      }
    }
  }
  &.compelx_doubleTeam {
    .el-select {
      .el-input {
        .el-input__inner {
          height: calc(2.2vw + 1px + 1px);
          line-height: 2.2vw;
          border-radius: 1.1vw;
          text-align: center;
        }
        .el-input__icon {
          width: 0.694vw;
          line-height: calc(2.2vw + 1px + 1px);
        }
      }
    }
  }
}

.mixtmt_pc .selectItem_cba {
  .el-select {
    &:hover {
      .el-input__inner,
      .el-icon-arrow-up::before {
        color: var(--mixtmt_greyColor6);
      }
      .el-input__inner {
        background-color: var(--mixtmt_subColor1_2);
      }
    }
  }
  .el-select .el-input__inner:focus,
  .el-select .el-input__inner:hover,
  .el-select:hover .el-input__inner,
  .el-select .el-input.is-focus .el-input__inner,
  .el-input__inner:focus {
    border-color: var(--mixtmt_greyColor7);
    color: var(--mixtmt_greyColor2);
  }
  &.transparentBg {
    .el-select {
      &:hover {
        .el-input__inner,
        .el-icon-arrow-up::before {
          color: var(--mixtmt_whiteColor);
        }
        .el-input__inner {
          background-color: var(--mixtmt_subColor1_2);
        }
      }
    }
    .el-select .el-input__inner:focus,
    .el-select .el-input__inner:hover,
    .el-select:hover .el-input__inner,
    .el-select .el-input.is-focus .el-input__inner,
    .el-input__inner:focus {
      border-color: var(--mixtmt_greyColor7);
      color: var(--mixtmt_whiteColor);
    }
    .el-select .el-input__inner:focus,
    .el-select .el-input__inner:hover,
    .el-select:hover .el-input__inner,
    .el-select .el-input.is-focus .el-input__inner,
    .el-input__inner:focus {
      border-color: var(--mixtmt_greyColor7);
      color: var(--mixtmt_whiteColor);
    }
  }
}
.selectItem_popper {
  .el-select-dropdown__item,
  .el-select-dropdown__empty {
    font-size: 0.972vw;
    padding: 0 1.042vw;
    height: 2.778vw;
    line-height: 2.778vw;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover,
  .el-select-dropdown__item.selected {
    color: var(--mixtmt_subColor1_1);
    background-color: var(--mixtmt_subColor1_2);
  }
  &.el-popper[x-placement^='bottom'] {
    margin-top: 0.974vw;
  }
}
</style>
